import React from 'react'
import PropTypes from 'prop-types'
import './index.scss'

const Price = ({ price, extraText, size }) => {
  if (typeof price !== 'number') {
    throw TypeError(`The price ${price} must be a number but was ${typeof price}`)
  }

  const roundedPrice = Math.round(price, 0)
  const formatedPrice = Number(roundedPrice).toLocaleString('nb-NO')

  return (
    <span className={`price-item ${size ? size : ''}`}>
      {formatedPrice},-{extraText && <span className="extra-text">{' '}{extraText}</span>}
    </span>
  )
}

Price.propTypes = {
  price: PropTypes.number.isRequired,
  extraText: PropTypes.string,
  size: PropTypes.string,
}

export default Price
